import { render, staticRenderFns } from "./table-secondary.vue?vue&type=template&id=536bd8f7&scoped=true&"
import script from "./table-secondary.vue?vue&type=script&lang=js&"
export * from "./table-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536bd8f7",
  null
  
)

export default component.exports